import React from 'react';

import { Box, Skeleton, Grid } from '@mui/material';

import { COLOR } from '../../../helpers/colors';
import { returnCountArr } from '../../../helpers/functions';

const textBox = (
  <Skeleton variant="text" animation="wave" color={COLOR.PH} style={{ width: '100%' }} />
);

const FilterPlaceholder = () => (
  <Grid item xs={12} sm={12} md={3}>
    <Box
      sx={{
        p: 2,
        border: `1px solid ${COLOR.borderColor}`,
        borderRadius: 1,
        display: { xs: 'none', sm: 'none', md: 'block' },
      }}
    >
      {returnCountArr(25).map(() => textBox)}
    </Box>
    <Box
      sx={{
        p: 2,
        mb: 2,
        border: `1px solid ${COLOR.borderColor}`,
        borderRadius: 1,
        display: { xs: 'block', sm: 'block', md: 'none' },
      }}
    >
      {returnCountArr(6).map(() => textBox)}
    </Box>
  </Grid>
);

export default FilterPlaceholder;
